// eslint-disable-next-line no-shadow
export enum SignInStatus {
  Success = 0,
  LockedOut = 1,
  RequiresVerification = 2,
  Failure = 3,
}
